import { JSX } from 'react';

import {
	SVGBettingSiteBetMgm,
	SVGBettingSiteDraftKings,
	SVGBettingSiteEspnBet,
	SVGBettingSiteFanduel,
	SVGBettingSiteKalshi,
	SVGBettingSiteOther,
	SVGBettingSitePolymarket
} from './SVGBettingSites';

export const BETTING_SITES_OPTIONS = [
	{ label: 'Kalshi', value: 'BETTING_SITE_KALSHI' },
	{ label: 'Polymarket', value: 'BETTING_SITE_POLYMARKET' },
	{ label: 'DraftKings', value: 'BETTING_SITE_DRAFTKINGS' },
	{ label: 'FanDuel', value: 'BETTING_SITE_FANDUEL' },
	{ label: 'BetMGM', value: 'BETTING_SITE_BETMGM' },
	{ label: 'ESPN Bet', value: 'BETTING_SITE_ESPN_BET' },
	{ label: 'Other', value: 'BETTING_SITE_OTHER' }
];

export const bettingSiteSvgs: Record<string, () => JSX.Element> = {
	BETTING_SITE_DRAFTKINGS: SVGBettingSiteDraftKings,
	BETTING_SITE_KALSHI: SVGBettingSiteKalshi,
	BETTING_SITE_POLYMARKET: SVGBettingSitePolymarket,
	BETTING_SITE_FANDUEL: SVGBettingSiteFanduel,
	BETTING_SITE_BETMGM: SVGBettingSiteBetMgm,
	BETTING_SITE_ESPN_BET: SVGBettingSiteEspnBet,
	BETTING_SITE_OTHER: SVGBettingSiteOther
};
